import script from "./RequestsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestsTable.vue?vue&type=script&setup=true&lang=js"

import "./RequestsTable.vue?vue&type=style&index=0&id=0b0d83ce&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b0d83ce"]])

export default __exports__